"use strict";function finishMiniCourseByRecordId$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.finishMiniCourseByRecordId$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.edu.finishMiniCourseByRecordId";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.15"},_a)),exports.finishMiniCourseByRecordId$=finishMiniCourseByRecordId$,exports.default=finishMiniCourseByRecordId$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/edu/finishMiniCourseByRecordId.js
// module id = 946
// module chunks = 106